import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import Account from '../screen/account/Account';
import Login from '../screen/auth/Login';
import NotFound from "../screen/NotFound";
import QuestionAnswer from '../screen/question-answer/QuestionAnswer';
import Home from '../screen/user/home/Home';
import Subcategory from '../screen/user/subcategory/subcategory';
import Mission from '../screen/user/mission/mission'
import MissionDetails from '../screen/user/mission-details/missiondetails'
import Qna from '../screen/user/qna/qna'
import Successfull from '../screen/user/last/successfull';
import Unsuccessfull from '../screen/user/last/unsuccessfull'
import ProtectedRoute from './ProtectedRoute';
import Profile from '../screen/profile/Profile';
import History from '../screen/profile/History'
import Maintinance from '../screen/maintinance'
import DailyLogin from '../screen/dailylogin'
import SpinWheel from '../screen/user/home/Spinwheel';
import HomeChallenge from '../screen/user/theme6/challenges/HomeChallenge';
import StartChallenge from '../screen/user/theme6/challenges/StartChallenge';
import MissionReward from '../screen/user/theme6/mission/MissionReward';
// import for theme 6
import Home6 from '../screen/user/theme6'
import Subcategory6 from '../screen/user/theme6/Subcategory/Subcategory'
import Mission6 from '../screen/user/theme6/mission/Mission'
import Mission_details6 from '../screen/user/theme6/Mission-details/Mission_details';
import Profile6 from '../screen/user/theme6/Profile/profile'
import History6 from '../screen/user/theme6/Profile/History'
import Favorite from '../screen/user/theme6/Profile/Favorite';
import Qna6 from '../screen/user/theme6/Qna/Start'
import Successfull6 from '../screen/user/theme6/last/Successfull';
import Unsuccessfull6 from '../screen/user/theme6/last/Unsuccessfull';
import Avatar from '../screen/user/home/Avatar';
import RewardHome from '../screen/user/home/RewardHome';
import DailyChallenges from '../screen/user/theme6/challenges/DailyChallenges';
import { appAction } from '../redux/app/app';
import { useDispatch } from "react-redux";
import BrandStore from '../screen/user/brandStore';
import MyVouhcers from '../screen/user/brandStore/myVouhcers';
import CardDetails from '../screen/user/brandStore/cardDetails';
import MissionComplete from '../screen/user/theme6/challenges/MissionComplete'
import StartQuiz from '../screen/user/theme6/challenges/StartQuiz';
import UserWallet from '../screen/user/theme6/wallet/UserWallet';
import TransactionHistory from '../screen/user/theme6/wallet/TransactionHistory';
import CardResult from '../screen/user/theme6/cardResult/CardResult';
import FavoriteMission from '../screen/user/theme6/Profile/FavoriteMission';
import SubcategoryMission from '../screen/user/theme6/Subcategory/SubcategoryMission';
import SubCategoryMission from '../screen/user/theme6/mission/SubCategoryMission';
// new routes of this color points










export default function Index() {
  const [reload, setReload] = useState(true);
  const isAuthenticatedAppId = JSON.parse(localStorage.getItem("pwa_app_id"));
  const [maintinanceMode, setMaintinanceMode] = useState(false)
  const navigate = useNavigate()

  const dispatch = useDispatch()

  const location = useLocation();
  const path = location.pathname; // <-- current URL path


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (isAuthenticatedAppId) {
          var app = await dispatch(appAction({ appId: isAuthenticatedAppId }));
          // console.log("app==========72", app?.payload?.data?.publisher_id?.isDefault)


          if (app?.payload?.data?.app_color === 6 && !app?.payload?.data?.publisher_id?.isDefault) {
            localStorage.clear();
            navigate("/", { replace: true });
          }

          if (app?.payload?.status == 200) {
            localStorage.setItem("is_maintinance_mode", JSON.stringify(app?.payload?.Config.is_maintinance_mode));
            setMaintinanceMode(app?.payload?.Config.is_maintinance_mode)
            if (JSON.parse(localStorage.getItem("pwa_app_theme")) && JSON.parse(localStorage.getItem("pwa_app_theme")) != app?.payload?.data.app_color) {
              localStorage.setItem("pwa_app_theme", JSON.stringify(app?.payload?.data.app_color));
              localStorage.setItem("is_default", JSON.stringify(!app?.payload?.data?.publisher_id?.isDefault));
              window.location.reload();
              // navigate('/');
            }
          }
        } else {

          navigate("/")

        }
      } catch (error) {
        console.log("Error:", error);
      }


    };

    fetchData();

  }, [dispatch, navigate])



  const theme = localStorage.getItem('pwa_app_theme')
  const DefaultApp = localStorage.getItem('is_default');


  return (
    // <BrowserRouter>
    <Routes>
      <Route path="/" element={<Login />} />

      <Route path={"/home"} element={<ProtectedRoute>{JSON.parse(localStorage.getItem('pwa_app_theme')) == 6 ? <Home6 /> : <Home />}</ProtectedRoute>} />
      <Route path='/home-challenge' element={<HomeChallenge />} />

      {/* select avatar and reward */}
      <Route path='/avatar' element={<Avatar />} />
      <Route path='/RewardHome' element={<RewardHome />} />


      <Route path='/mission-reward' element={<MissionReward />} />
      <Route path='/daily-challenge' element={<DailyChallenges />} />
      <Route path='/start-quiz/:id' element={<StartQuiz />} />
      <Route path='/start-challenge/:challengeID' element={<StartChallenge />} />

      <Route path='/wallet' element={<UserWallet />} />
      <Route path='/transaction-history' element={<TransactionHistory />} />
      <Route path='/mission-complete/:challengeID' element={<MissionComplete />} />
      <Route path='/subcategory-mission/:subcategory_id' element={<SubcategoryMission />} />
      <Route path='/mission/reward/:subcategoryId' element={<SubCategoryMission />} />

      <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
      <Route path="/favorite" element={<ProtectedRoute><Favorite /></ProtectedRoute>} />
      <Route path="/favorite-mission-reward" element={<ProtectedRoute><FavoriteMission /></ProtectedRoute>} />
      <Route path="/qns-ans" element={<ProtectedRoute><QuestionAnswer /></ProtectedRoute>} />
      {/* <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} /> */}
      <Route path="/sub-category" element={<ProtectedRoute>{JSON.parse(theme) == 6 ? <Subcategory6 /> : <Subcategory />}</ProtectedRoute>} />
      <Route path="/missions" element={<ProtectedRoute>{JSON.parse(theme) == 6 ? <Mission6 /> : <Mission />}</ProtectedRoute>} />
      <Route path="/mission-detail" element={<ProtectedRoute>{JSON.parse(theme) == 6 ? <Mission_details6 /> : <MissionDetails />}</ProtectedRoute>} />
      <Route path="/mission-qna" element={<ProtectedRoute>{JSON.parse(theme) == 6 ? <Qna6 /> : <Qna />}</ProtectedRoute>} />
      <Route path="/mission-success/:challengeID" element={<ProtectedRoute>{JSON.parse(theme) == 6 ? <Successfull6 /> : <Successfull />}</ProtectedRoute>} />
      <Route path="/mission-unsuccess" element={<ProtectedRoute>{JSON.parse(theme) == 6 ? <Unsuccessfull6 /> : <Unsuccessfull />}</ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute>{JSON.parse(theme) == 6 ? <Profile6 /> : <Profile />}</ProtectedRoute>} />
      <Route path="/history" element={<ProtectedRoute>{JSON.parse(theme) == 6 ? <History6 /> : <History />}</ProtectedRoute>} />
      <Route path="/dailylogin" element={<ProtectedRoute><DailyLogin /></ProtectedRoute>} />
      <Route path="/spinwheel" element={<ProtectedRoute><SpinWheel /></ProtectedRoute>} />
      {/* //for theme 6 */}
      <Route path="/brandStore" element={<ProtectedRoute><BrandStore /></ProtectedRoute>} />
      <Route path="/myVouchers" element={<ProtectedRoute><MyVouhcers /></ProtectedRoute>} />
      <Route path="/cardDetails/:id" element={<ProtectedRoute><CardDetails /></ProtectedRoute>} />
      <Route path="/cardResult/:id" element={<ProtectedRoute><CardResult /></ProtectedRoute>} />
      <Route path="/maintinance" element={
        JSON.parse(localStorage.getItem('is_maintinance_mode'))
          ? <Maintinance />
          : <Navigate to="/home" replace />
      } />
      <Route
        path="*"
        element={
          (() => {
            return <Navigate to="/" replace />;
          })()

        }
      />

    </Routes>
    // </BrowserRouter> 
  )
}


